<template>
 

<div class="modal" tabindex="-1" aria-labelledby="previewArticleLabel" aria-hidden="true" id="previewEmbed" >
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Embed {{ embed }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="getRemove()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <form method="post"  @submit.prevent="isEmbed">
      <div class="modal-body">
       
          <div class="form-group" :class="messages ? 'has-error' : ''">
            <label for="recipient-name" class="col-form-label control-label">Url Embed {{ embed }}:</label>
            <input type="text" v-model="textembed" class="form-control" id="recipient-name" >
            <label v-if="messages !== ''" for class="control-label">{{ messages }}</label>
            <p class="help-block" v-if="embed =='Youtube'">Contoh : https://www.youtube.com/watch?v=WdDOAo_dW7o</p>
            <p class="help-block" v-else-if="embed =='Instagram'">Contoh : https://www.instagram.com/p/CizfJzUDXau/ </p>
            <p class="help-block" v-else-if="embed =='Tiktok'">Contoh : https://www.tiktok.com/@suaradotcom/video/7146124409374248218</p>
            <p class="help-block" v-else-if="embed =='Twitter'">Contoh : https://twitter.com/suaracommedia/status/440333876620062720</p>

             <p class="help-block" v-else-if="embed =='Serbada'">Contoh : https://www.serbada.com/product/cotton-flower-by-calvin-kainn-20191209141847</p>
          </div>


             
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary" >Convert</button> 
      </div>
      </form>
    </div>
  </div>
</div>

</template>

<style type="text/css">
.help-block {
    display: block;
    margin-top: 6px;
    margin-bottom: 10px;
    color: #737373;
    font-size: 12px;
}
</style>

<script>
import _ from 'lodash';
import $ from "jquery";
export default {
    props: ['loading','embed'],
    name: "PreviewEmbed",
    data() {
            return {
                textembed:'',
                videoId:'',
                messages:'',
            }
        },

    methods: {
        isEmbed () {
            
            if(this.embed == 'Youtube')
            {
                 
                return this.EmbedYoutube(this.textembed);
            }else if(this.embed == 'Instagram'){
                 
                var convert = this.getPathFromUrlIG(this.textembed);
               
                return this.EmbedInstagram(convert); 
            }else if(this.embed == 'Tiktok'){
                 
                var convert = this.getPathFromUrlTiktok(this.textembed);
                return this.EmbedTiktok(convert);
            }else if(this.embed == 'Serbada'){     
                 
                var convert = this.getPathFromUrlSerbada(this.textembed);
                return this.EmbedSerbada(convert);
            }else if(this.embed == 'Twitter'){     
                 console.log(this.textembed)
                var convert = this.getPathFromUrlTwitter(this.textembed);
                return this.EmbedTwitter(convert); 
               
            } 


        },
        EmbedYoutube(data)
        {   

            var videoId = this.getYoutube(data);
           
            if(videoId !='error')
            {
                var iframed = '<iframe width="560" height="315" src="//www.youtube.com/embed/' +
                  videoId +
                  '" frameborder="0" allowfullscreen></iframe>';
                 this.$emit('getIframe', iframed);
                 this.getRemove();
            }else{
                this.messages = 'Hanya dizinkan embed video dari kanal Youtube check contoh sample url';
            }    
             

        },
        EmbedInstagram(data){
             
             if(data !='error')
             {
                    
                  var videoId  = data + '/embed/captioned'; 
                  var iframed = '<iframe width="560" height="315" src="//www.instagram.com/'+ videoId +'"  frameborder="0" allowfullscreen></iframe>';

                   // console.log(iframed);

                   this.$emit('getIframe', iframed);
                   this.getRemove();
             }else{
                this.messages = 'Hanya dizinkan embed video dari kanal Instagram check contoh sample url';
             }  
        },
        EmbedTiktok(data){
                 
             if(data !='error')
             {
                 var videoId  = 'embed/v2/'+ data;
                 var iframed = '<iframe width="560" height="315" src="//www.tiktok.com/'+ videoId +'" frameborder="0" allowfullscreen></iframe>';
                 this.$emit('getIframe', iframed);
                 this.getRemove();
            }else{
                
                 this.messages = 'Hanya dizinkan embed video dari kanal Tiktok check contoh sample url';
            }
        },
        EmbedSerbada(data){
           
            
            if(data !='error')
            {
                var videoId  = 'widget/detail/'+ data;
                var iframed = '<iframe width="760" height="515" src="//www.serbada.com/'+ videoId +'"  frameborder="0" allowfullscreen></iframe>';
                this.$emit('getIframe', iframed);
                this.getRemove();
            }else{
               this.messages = 'Hanya dizinkan embed video dari kanal Serbada';  
            }
        },
        EmbedTwitter(data){
           
             
            if(data !='error')
            {
                var url = this.getPathFromUrl(data).replace("x.com", "twitter.com");
                var iframed = '<iframe  src="https://twitframe.com/show?url=' +
                                url +
                                '" width="560" height="315" frameborder="0"></iframe>';
                this.$emit('getIframe', iframed);
                this.getRemove();
            }else{
               this.messages = 'Hanya dizinkan embed video dari kanal (X) Twitter';  
            }
        },
        getPathFromUrlIG(url) {
                   if (url.indexOf('<blockquote') > -1)
                    {
                      return "error"; 
                    }else{

                        var baseUrl = url.split(/[?#]/)[0];
                
                        var param_check = baseUrl.split("/");
                        if(param_check[2] =='www.instagram.com')
                        {
                            var pathname = new URL(baseUrl).pathname;
                            if(param_check[3] =='reel')
                            {
                                var param = pathname.split("reel");
                                var param_url = param[1].split("/");
                                return 'reel/' + param_url[1];

                            }else{

                               
                                var param = pathname.split("/");
                                
                              //  var param_url = param[2].split("/");
                                return 'p/' + param[2];
                            }  
                            
                        }else{

                            return "error"; 
                        }



                    }
                
        },
        getPathFromUrlTiktok(url) {
            if (url.indexOf('<blockquote') > -1)
            {
              return "error"; 
            }else{
                var baseUrl = url.split(/[?#]/)[0];
                var param_check = baseUrl.split("/");
                if(param_check[2] =='www.tiktok.com')
                {

                    var pathname = new URL(baseUrl).pathname;
                    var param = pathname.split("video");
                    var param_url = param[1].split("/");
                    return param_url[1];

                }else{
                     return "error";
                }  
            }    
        },
        getPathFromUrlSerbada(url) {
          
                var baseUrl = url.split(/[?#]/)[0];
                var param_check = baseUrl.split("/");
                if(param_check[2] =='www.serbada.com')
                {

                    var pathname = new URL(baseUrl).pathname;
                    var param = pathname.split("product");
                    var param_url = param[1].split("/");
                    return param_url[1];

                }else{
                     return "error";
                }  

                
        },
        getPathFromUrlTwitter(url){
             var baseUrl = url.split(/[?#]/)[0];
                var param_check = baseUrl.split("/");
                
                if(param_check[2] =='twitter.com')
                {
                     return url;
                }else if(param_check[2] =='x.com'){     
                    return url;
                }else{
                     return "error";
                }  
        },
        getYoutube(url) {

            if (url.indexOf('https://youtu.be') > -1)
            {
              return "error"; 
            }else{

                var baseUrl = url.split(/[?#]/)[0];

                 var param_url = baseUrl.split("/");
                 if(param_url[2] =='www.youtube.com')
                 {
                        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                        var match = url.match(regExp);
                        var param = match[0].split("/");
                        if(match && match[2].length == 11 || param[2] =='www.youtube.com') {
                          return match[2];
                        } else {
                          return "error";
                        }
                 }else{
                     return "error";
                 }   

            }    
        },
        getPathFromUrl(url){
            return url.split(/[?#]/)[0];          
           
        },
        getRemove(){
           this.messages = ''; 
           this.textembed = '';
        }
        
    }
}
</script>

<style scoped>
.modal-previewArticle .modal-content {
    background-color: #EAECF0;
    border-radius: 15px;
    border: none;
}
.preview-img {
    background: #fff;
    border-radius: 15px;
}
.preview-img p {
    padding: 10px;
}
.preview-img img {
    width: 100%;
    border-radius: 15px;
}
.preview-summary {
    border-left-color: black;
    padding: 1rem;
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
    border: 0 solid #F8222E;
    border-left-width: .25rem;
    border-radius: .25rem;
    border-top: 1px solid #BDBDBD;
    border-right: 1px solid #BDBDBD;
    border-bottom: 1px solid #BDBDBD;
    font-weight: 600;
    font-size: 12px;
}
.preview-tag ul {
    list-style-type: none;
    display: flex;
    justify-content: flex-start;
    -webkit-padding-start: 0;
    padding-inline-start: 0;
    margin-bottom: 0;
}
.preview-tag ul li {
    border: 1px solid #828282;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 4px 6px;
    margin-right: 10px;
}
.preview-tag ul li a {
    color: #828282;
    text-decoration: none;
}
.preview-desc img {
    width: 100%;
    height: auto;
}
.title {
    margin-top: 10px;
    font-size: 25px;
}
.sub-title {
    margin-top: 10px;
    font-size: 18px;
}
img {
    width: 100%;
    height: auto;
}
figure {
    text-align: center;
}
@media only screen and (min-width: 600px) and (max-width: 800px) {
    .modal-dialog {
        max-width: 600px;
    }
}
@media only screen and (min-width: 800px) {
    .modal-dialog {
        max-width: 700px;
    }
}

.has-error .checkbox, .has-error .checkbox-inline, .has-error .control-label, .has-error .help-block, .has-error .radio, .has-error .radio-inline, .has-error.checkbox label, .has-error.checkbox-inline label, .has-error.radio label, .has-error.radio-inline label {
    color: #c41411;
}

.form-group.has-error .form-control {
    background-color: #fad8d9!important;
}

.has-error .form-control {
    border-color: #c41411;
    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}
</style>
